var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarketing = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3H5L9 0V10L5 8H4L5 11H3L2 8H0V3ZM1 4H5.33333L8 2V8.38197L5.23607 7H1V4Z",
    fill: "#32373E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.49995C12 4.25368 11.41 3.14596 10.2236 2.55273L9.77637 3.44716C10.5899 3.85394 11 4.59276 11 5.49995C11 6.01554 10.8908 6.42228 10.6965 6.74533C10.5029 7.06718 10.2055 7.33817 9.77637 7.55273L10.2236 8.44716C10.7945 8.16172 11.247 7.77018 11.5534 7.26076C11.8591 6.75255 12 6.15928 12 5.49995Z",
    fill: "#32373E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarketing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Marketing.d22124f01e77adb47ec5e211b731df3e.svg";